import React, {useEffect, useState} from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';

import logo from '../../assets/images/01_Logo_HSE_full_rus_Pantone.png';
import {Button, Form, NavDropdown} from "react-bootstrap";


const expand = false

const MyNavbar = () => {
    return (
        <Navbar key={expand} expand={expand} className="mb-3m fixed-top">
            <Container fluid>
                <Navbar.Brand href="#"></Navbar.Brand>
                <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} style={{backgroundColor: "#FFFFFF"}}/>
                <Navbar.Offcanvas
                    id={`offcanvasNavbar-expand-${expand}`}
                    aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                    placement="end"
                >
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                            <b>Навигация:</b>
                        </Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <Nav className="justify-content-end flex-grow-1 pe-3">
                            <Nav.Link href="/">&nbsp;&nbsp;&nbsp;&nbsp;Главная</Nav.Link>
                            <Nav.Link href="/step1">1) Кадровые вопросы</Nav.Link>
                            <Nav.Link href="/step2">2) Медицинский осмотр</Nav.Link>
                            <Nav.Link href="/step3">3) Оформление электронного пропуска</Nav.Link>
                            <Nav.Link href="/step4">4) Здания НИУ ВШЭ</Nav.Link>
                            <Nav.Link href="/step5">5) Единый личный кабинет работника</Nav.Link>
                            <Nav.Link href="/step6">6) Оборудовать рабочее место</Nav.Link>
                            <Nav.Link href="/step7">7) Заработная плата</Nav.Link>
                            <Nav.Link href="/step8">8) Базовый стандарт профессиональных компетенций</Nav.Link>
                            <Nav.Link href="/step9">9) Адаптационные семинары</Nav.Link>
                            <Nav.Link href="/step10">10) Центр повышения квалификации</Nav.Link>
                            <Nav.Link href="/step11">11) Кадровый резерв</Nav.Link>
                        </Nav>
                    </Offcanvas.Body>
                </Navbar.Offcanvas>
            </Container>
        </Navbar>
    );
};

export default MyNavbar;